// client/src/utils/nationalities.js
const nationalities = [
    { value: 'afghan', label: 'Afghan' },
    { value: 'albanian', label: 'Albanian' },
    { value: 'algerian', label: 'Algerian' },
    { value: 'american', label: 'American' },
    { value: 'andorran', label: 'Andorran' },
    { value: 'angolan', label: 'Angolan' },
    { value: 'antiguans', label: 'Antiguans' },
    { value: 'argentinean', label: 'Argentinean' },
    { value: 'armenian', label: 'Armenian' },
    { value: 'australian', label: 'Australian' },
    { value: 'austrian', label: 'Austrian' },
    { value: 'azerbaijani', label: 'Azerbaijani' },
    { value: 'bahamian', label: 'Bahamian' },
    { value: 'bahraini', label: 'Bahraini' },
    { value: 'bangladeshi', label: 'Bangladeshi' },
    { value: 'barbadian', label: 'Barbadian' },
    { value: 'barbudans', label: 'Barbudans' },
    { value: 'batswana', label: 'Batswana' },
    { value: 'belarusian', label: 'Belarusian' },
    { value: 'belgian', label: 'Belgian' },
    { value: 'belizean', label: 'Belizean' },
    { value: 'beninese', label: 'Beninese' },
    { value: 'bhutanese', label: 'Bhutanese' },
    { value: 'bolivian', label: 'Bolivian' },
    { value: 'bosnian', label: 'Bosnian' },
    { value: 'brazilian', label: 'Brazilian' },
    { value: 'british', label: 'British' },
    { value: 'bruneian', label: 'Bruneian' },
    { value: 'bulgarian', label: 'Bulgarian' },
    { value: 'burkinabe', label: 'Burkinabe' },
    { value: 'burmese', label: 'Burmese' },
    { value: 'burundian', label: 'Burundian' },
    { value: 'cambodian', label: 'Cambodian' },
    { value: 'cameroonian', label: 'Cameroonian' },
    { value: 'canadian', label: 'Canadian' },
    { value: 'cape verdean', label: 'Cape Verdean' },
    { value: 'central african', label: 'Central African' },
    { value: 'chadian', label: 'Chadian' },
    { value: 'chilean', label: 'Chilean' },
    { value: 'chinese', label: 'Chinese' },
    { value: 'colombian', label: 'Colombian' },
    { value: 'comoran', label: 'Comoran' },
    { value: 'congolese', label: 'Congolese' },
    { value: 'costa rican', label: 'Costa Rican' },
    { value: 'croatian', label: 'Croatian' },
    { value: 'cuban', label: 'Cuban' },
    { value: 'cypriot', label: 'Cypriot' },
    { value: 'czech', label: 'Czech' },
    { value: 'danish', label: 'Danish' },
    { value: 'djibouti', label: 'Djibouti' },
    { value: 'dominican', label: 'Dominican' },
    { value: 'dutch', label: 'Dutch' },
    { value: 'east timorese', label: 'East Timorese' },
    { value: 'ecuadorean', label: 'Ecuadorean' },
    { value: 'egyptian', label: 'Egyptian' },
    { value: 'emirian', label: 'Emirian' },
    { value: 'equatorial guinean', label: 'Equatorial Guinean' },
    { value: 'eritrean', label: 'Eritrean' },
    { value: 'estonian', label: 'Estonian' },
    { value: 'ethiopian', label: 'Ethiopian' },
    { value: 'fijian', label: 'Fijian' },
    { value: 'filipino', label: 'Filipino' },
    { value: 'finnish', label: 'Finnish' },
    { value: 'french', label: 'French' },
    { value: 'gabonese', label: 'Gabonese' },
    { value: 'gambian', label: 'Gambian' },
    { value: 'georgian', label: 'Georgian' },
    { value: 'german', label: 'German' },
    { value: 'ghanaian', label: 'Ghanaian' },
    { value: 'greek', label: 'Greek' },
    { value: 'grenadian', label: 'Grenadian' },
    { value: 'guatemalan', label: 'Guatemalan' },
    { value: 'guinea-bissauan', label: 'Guinea-Bissauan' },
    { value: 'guinean', label: 'Guinean' },
    { value: 'guyanese', label: 'Guyanese' },
    { value: 'haitian', label: 'Haitian' },
    { value: 'herzegovinian', label: 'Herzegovinian' },
    { value: 'honduran', label: 'Honduran' },
    { value: 'hungarian', label: 'Hungarian' },
    { value: 'icelander', label: 'Icelander' },
    { value: 'indian', label: 'Indian' },
    { value: 'indonesian', label: 'Indonesian' },
    { value: 'iranian', label: 'Iranian' },
    { value: 'iraqi', label: 'Iraqi' },
    { value: 'irish', label: 'Irish' },
    { value: 'italian', label: 'Italian' },
    { value: 'ivorian', label: 'Ivorian' },
    { value: 'jamaican', label: 'Jamaican' },
    { value: 'japanese', label: 'Japanese' },
    { value: 'jordanian', label: 'Jordanian' },
    { value: 'kazakhstani', label: 'Kazakhstani' },
    { value: 'kenyan', label: 'Kenyan' },
    { value: 'kittian and nevisian', label: 'Kittian and Nevisian' },
    { value: 'kuwaiti', label: 'Kuwaiti' },
    { value: 'kyrgyz', label: 'Kyrgyz' },
    { value: 'laotian', label: 'Laotian' },
    { value: 'latvian', label: 'Latvian' },
    { value: 'lebanese', label: 'Lebanese' },
    { value: 'liberian', label: 'Liberian' },
    { value: 'libyan', label: 'Libyan' },
    { value: 'liechtensteiner', label: 'Liechtensteiner' },
    { value: 'lithuanian', label: 'Lithuanian' },
    { value: 'luxembourger', label: 'Luxembourger' },
    { value: 'macedonian', label: 'Macedonian' },
    { value: 'malagasy', label: 'Malagasy' },
    { value: 'malawian', label: 'Malawian' },
    { value: 'malaysian', label: 'Malaysian' },
    { value: 'maldivan', label: 'Maldivan' },
    { value: 'malian', label: 'Malian' },
    { value: 'maltese', label: 'Maltese' },
    { value: 'marshallese', label: 'Marshallese' },
    { value: 'mauritanian', label: 'Mauritanian' },
    { value: 'mauritian', label: 'Mauritian' },
    { value: 'mexican', label: 'Mexican' },
    { value: 'micronesian', label: 'Micronesian' },
    { value: 'moldovan', label: 'Moldovan' },
    { value: 'monacan', label: 'Monacan' },
    { value: 'mongolian', label: 'Mongolian' },
    { value: 'moroccan', label: 'Moroccan' },
    { value: 'mosotho', label: 'Mosotho' },
    { value: 'motswana', label: 'Motswana' },
    { value: 'mozambican', label: 'Mozambican' },
    { value: 'namibian', label: 'Namibian' },
    { value: 'nauruan', label: 'Nauruan' },
    { value: 'nepalese', label: 'Nepalese' },
    { value: 'new zealander', label: 'New Zealander' },
    { value: 'ni-vanuatu', label: 'Ni-Vanuatu' },
    { value: 'nicaraguan', label: 'Nicaraguan' },
    { value: 'nigerien', label: 'Nigerien' },
    { value: 'north korean', label: 'North Korean' },
    { value: 'northern irish', label: 'Northern Irish' },
    { value: 'norwegian', label: 'Norwegian' },
    { value: 'omani', label: 'Omani' },
    { value: 'pakistani', label: 'Pakistani' },
    { value: 'palestinian', label: 'Palestinian' },
    { value: 'palauan', label: 'Palauan' },
    { value: 'panamanian', label: 'Panamanian' },
    { value: 'papua new guinean', label: 'Papua New Guinean' },
    { value: 'paraguayan', label: 'Paraguayan' },
    { value: 'peruvian', label: 'Peruvian' },
    { value: 'polish', label: 'Polish' },
    { value: 'portuguese', label: 'Portuguese' },
    { value: 'qatari', label: 'Qatari' },
    { value: 'romanian', label: 'Romanian' },
    { value: 'russian', label: 'Russian' },
    { value: 'rwandan', label: 'Rwandan' },
    { value: 'saint lucian', label: 'Saint Lucian' },
    { value: 'salvadoran', label: 'Salvadoran' },
    { value: 'samoan', label: 'Samoan' },
    { value: 'san marinese', label: 'San Marinese' },
    { value: 'sao tomean', label: 'Sao Tomean' },
    { value: 'saudi', label: 'Saudi' },
    { value: 'scottish', label: 'Scottish' },
    { value: 'senegalese', label: 'Senegalese' },
    { value: 'serbian', label: 'Serbian' },
    { value: 'seychellois', label: 'Seychellois' },
    { value: 'sierra leonean', label: 'Sierra Leonean' },
    { value: 'singaporean', label: 'Singaporean' },
    { value: 'slovakian', label: 'Slovakian' },
    { value: 'slovenian', label: 'Slovenian' },
    { value: 'solomon islander', label: 'Solomon Islander' },
    { value: 'somali', label: 'Somali' },
    { value: 'south african', label: 'South African' },
    { value: 'south korean', label: 'South Korean' },
    { value: 'spanish', label: 'Spanish' },
    { value: 'sri lankan', label: 'Sri Lankan' },
    { value: 'sudanese', label: 'Sudanese' },
    { value: 'surinamer', label: 'Surinamer' },
    { value: 'swazi', label: 'Swazi' },
    { value: 'swedish', label: 'Swedish' },
    { value: 'swiss', label: 'Swiss' },
    { value: 'syrian', label: 'Syrian' },
    { value: 'taiwanese', label: 'Taiwanese' },
    { value: 'tajik', label: 'Tajik' },
    { value: 'tanzanian', label: 'Tanzanian' },
    { value: 'thai', label: 'Thai' },
    { value: 'togolese', label: 'Togolese' },
    { value: 'tongan', label: 'Tongan' },
    { value: 'trinidadian or tobagonian', label: 'Trinidadian or Tobagonian' },
    { value: 'tunisian', label: 'Tunisian' },
    { value: 'turkish', label: 'Turkish' },
    { value: 'turkmen', label: 'Turkmen' },
    { value: 'tuvaluan', label: 'Tuvaluan' },
    { value: 'ugandan', label: 'Ugandan' },
    { value: 'ukrainian', label: 'Ukrainian' },
    { value: 'uruguayan', label: 'Uruguayan' },
    { value: 'uzbekistani', label: 'Uzbekistani' },
    { value: 'venezuelan', label: 'Venezuelan' },
    { value: 'vietnamese', label: 'Vietnamese' },
    { value: 'welsh', label: 'Welsh' },
    { value: 'yemenite', label: 'Yemenite' },
    { value: 'zambian', label: 'Zambian' },
    { value: 'zimbabwean', label: 'Zimbabwean' }
];

export default nationalities;